import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function BookingSuccessPopup({ 
  isOpen, 
  onClose,
  bookingId: _bookingId 
}: { 
  isOpen: boolean; 
  onClose: () => void;
  bookingId?: string;
}) {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
    } else {
      setTimeout(() => setIsVisible(false), 300); // fade out
    }
  }, [isOpen]);

  if (!isOpen && !isVisible) return null;

  return (
    <div className={`fixed inset-0 z-[200] flex items-center justify-center bg-black/40 px-4 transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0'}`}>
      <div className={`w-full max-w-[420px] rounded-[24px] bg-white p-8 shadow-[0_10px_40px_rgba(0,0,0,0.2)] text-center transition-all duration-300 ${isOpen ? 'scale-100 translate-y-0' : 'scale-95 translate-y-4'}`}>
        <div className="mx-auto flex h-[80px] w-[80px] items-center justify-center rounded-full bg-[#EAF6D4] mb-6">
          <span className="text-[40px] text-[#86AE3C]">✓</span>
        </div>
        
        <h2 className="font-host text-[26px] font-semibold text-black leading-tight">
          Your booking is being processed.
        </h2>
        
        <p className="mt-3 font-poppins text-[14px] text-[#555555] leading-relaxed">
          Your booking request is currently being reviewed, 
          and a final confirmation email will be sent to you once it is approved.
        </p>

        <div className="mt-8 flex flex-col gap-3">
          <button
            type="button"
            onClick={() => {
              onClose();
              navigate('/');
            }}
            className="flex min-h-[52px] w-full items-center justify-center rounded-full bg-[#FF6A1A] px-6 font-poppins text-[14px] font-bold text-white transition-all duration-200 hover:bg-[#E55A12] hover:-translate-y-0.5 shadow-md cursor-pointer"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}
